import './App.css';
import IndexComponent from './Index.tsx';

function App() {
  return <IndexComponent/>;
}

export default App;
